import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/alerts")({
  staticData: {
    title: "common.alerts",
  },
});
